// extracted by mini-css-extract-plugin
export var compactFilters = "_f5-4";
export var detailImage = "_f5-1";
export var dropdownContainer = "_f5-2";
export var imageContainer = "_f5-0";
export var selectedCard = "_f5-3";